

import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { ConfirmationService } from 'tn-custom-primeng/api';
import { ScheduleConstants, ScheduleMethodType } from 'tnx-admin-service/schedulejob/constants';
import { ScheduleJobService } from 'tnx-admin-service/schedulejob/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, ModelSchema } from 'tnx-shared';
@Component({
    selector: 'schedulejob',
    templateUrl: './schedulejob.component.html',
    styleUrls: ['./schedulejob.component.scss'],
    providers: [ComponentContextService],
})
export class ScheduleJobComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _scheduleJobService: ScheduleJobService,
        private _confirmService: ConfirmationService
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._scheduleJobService;
        this.setting.objectName = ' công việc';
        this.setting.popupSize.height = 600;
        this.setting.modelSchemas = [
            new ModelSchema({
                field: 'codeJob',
                name: 'Mã công việc',
                fullName: 'Mã công việc',
                description: 'Mã công việc',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'data',
                name: 'Dữ liệu gửi kèm (json)',
                fullName: 'Dữ liệu gửi kèm (json)',
                description: 'Dữ liệu gửi kèm (json)',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'description',
                name: 'Mô tả',
                fullName: 'Mô tả',
                description: 'Mô tả',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'multipleRunning',
                name: 'Hình thức chạy',
                fullName: 'Hình thức chạy',
                description: 'Công việc chạy tuần tự hoặc song song',
                dataType: 'boolean',
            }),
            new ModelSchema({
                field: 'name',
                name: 'Tên công việc',
                fullName: 'Tên công việc',
                description: 'Tên công việc',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'replyTo',
                name: 'Topic RabbitMQ',
                fullName: 'Topic của RabbitMQ',
                description: 'Topic của RabbitMQ',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'status',
                name: 'Trạng thái',
                fullName: 'Trạng thái',
                description: 'Trạng thái',
                dataType: 'int'
            }),
            new ModelSchema({
                field: 'timeout',
                name: 'Thời gian timeout (giây)',
                fullName: 'Thời gian timeout (giây)',
                description: 'Thời gian timeout (giây)',
                dataType: 'int'
            }),
            new ModelSchema({
                field: 'created',
                name: 'Thời gian tạo',
                fullName: 'Thời gian tạo',
                description: 'Thời gian tạo',
                dataType: 'datetime',
            }),
        ];

        this.setting.cols = [
            new ColumnSchemaBase({
                field: 'codeJob',
                fullTextSearch: true
            }),
            new ColumnSchemaBase({
                field: 'name',
                fullTextSearch: true
            }),
            new ColumnSchemaBase({
                field: 'description',
                fullTextSearch: true
            }),
            new ColumnSchemaBase({ field: 'data' }),
            new ColumnSchemaBase({
                field: 'multipleRunning',
                dataSource: ScheduleConstants.RunningTypeDataSource,
                displayField: 'labelStatus',
                valueField: 'value'
            }),
            new ColumnSchemaBase({ field: 'replyTo' }),
            new ColumnSchemaBase({ field: 'timeout' }),
            new ColumnSchemaBase({
                field: 'created',
                format: 'normal'
            }),
            new ColumnSchemaBase({
                field: 'status',
                dataType: 'status',
                dataTypeRefField: 'status',
                dataSource: this.getShouldScheduleMethodTypeDataSource(true),
                displayField: 'labelStatus',
                valueField: 'value'
            }),

        ];
        super.ngOnInit();
    }

    getShouldScheduleMethodTypeDataSource(all: boolean) {
        return all ? ScheduleConstants.ScheduleMethodTypeDataSource : ScheduleConstants.ScheduleMethodTypeDataSource.filter(o => o.value == ScheduleMethodType.Start || o.value == ScheduleMethodType.Stop);
    }
    //#region Check Disabled Model

    isDisabledStart(data: any) {
        return this.isDisabled(data, ScheduleMethodType.Start);
    }

    isDisabledPause(data: any) {
        return this.isDisabled(data, ScheduleMethodType.Pause);
    }

    isDisabledStop(data: any) {
        return this.isDisabled(data, ScheduleMethodType.Stop);
    }

    isDisabledResume(data: any) {
        return this.isDisabled(data, ScheduleMethodType.Resume);
    }

    isDisabled(data: any, currentStatus: number) {
        const status = data.status;
        const hidden = new Array();

        switch (status) {
            case ScheduleMethodType.Start:
            case ScheduleMethodType.Resume:
                hidden.push(ScheduleMethodType.Start, ScheduleMethodType.Resume);
                break;
            case ScheduleMethodType.Stop:
                hidden.push(ScheduleMethodType.Stop, ScheduleMethodType.Pause, ScheduleMethodType.Resume);
                break;
            case ScheduleMethodType.Pause:
                hidden.push(ScheduleMethodType.Pause);
                break;
            default: break;
        }

        return hidden.includes(currentStatus);
    }

    //#endregion

    //#region Handle Change Job

    async changeJob_Start(data: any) {
        await this.changeJob(data, ScheduleMethodType.Start);
    }

    async changeJob_Pause(data: any) {
        await this.changeJob(data, ScheduleMethodType.Pause);
    }

    async changeJob_Stop(data: any) {
        await this.changeJob(data, ScheduleMethodType.Stop);
    }

    async changeJob(data: any, currentStatus: number) {
        const status = data.status;
        currentStatus = currentStatus == ScheduleMethodType.Start && status == ScheduleMethodType.Pause ? ScheduleMethodType.Resume : currentStatus;
        const confirmStatus = ScheduleConstants.ScheduleMethodTypeDataSource
            .filter(o => o.value == currentStatus)
            .pop();

        this._confirmService.confirm({
            acceptLabel: this._translateService.instant('CONFIRM.ACCEPT_LABEL'),
            rejectLabel: this._translateService.instant('CONFIRM.REJECT_LABEL'),
            message: confirmStatus.confirmMessage,
            header: confirmStatus.confirmHeader,
            accept: async () => {
                await this._scheduleJobService.changeJobStatus(data.id, currentStatus)
                    .then(rs => {
                        if (!rs.success) {
                            this._notifierService.showError(rs.console.error);
                            return;
                        }

                        this._notifierService.showSuccess(rs.message);
                    }).catch(err => {
                        this._notifierService.showWarning('Thao tác thất bại! Xin vui lòng thử lại sau');
                    });
                this.reload();
            }
        });
    }

    //#endregion Handle Change Job

    async restartServer(data: any) {
        await this._scheduleJobService.restartServer(data);
        this.reload();
    }

    async afterGetData(): Promise<void> {
        for (const item of this.model.dataSource) {
            item.classStatus = ScheduleConstants.ScheduleMethodTypeDataSource
                .filter(o => o.value == item.status)
                .map(o => o.styleClass).pop();
        }
    }
}
